interface EmailFormProps {
  privacyUrl: string;
  subscriptionUrl: string;
}

export default function EmailForm({
  privacyUrl,
  subscriptionUrl,
}: EmailFormProps) {
  return (
    <form action={subscriptionUrl} method="post" target="_blank">
      <h2>Meld deg på nyhetsbrev</h2>
      <div className="form-control">
        <label htmlFor="email">E-post</label>
        <div className="submit-field">
          <input id="email" type="email" name="EMAIL" required />
          <button className="btn" name="subscribe" type="submit">
            Meld deg på
          </button>
        </div>
      </div>
      <div className="form-control">
        <input id="confirm" type="checkbox" required />
        <label htmlFor="confirm">
          Jeg aksepterer Diakonhjemmet stiftelses{" "}
          <a href={privacyUrl}>personvernsvilkår</a>
        </label>
      </div>
    </form>
  );
}
